import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	betaLozenge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	disclaimerText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	infoIconLabel: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	aiIconLabel: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	betaLozenge: {
		id: 'atlassian-intelligence.common.ai-footer.beta-lozenge',
		defaultMessage: 'Beta',
		description: 'Text in beta lozenge in the footer.',
	},
	disclaimerText: {
		id: 'atlassian-intelligence.common.ai-footer.disclaimer-text',
		defaultMessage: 'Uses AI. Verify results.',
		description: 'Info Text in the footer.',
	},
	infoIconLabel: {
		defaultMessage: 'Info',
		id: 'atlassian-intelligence.common.ai-footer.info-icon-label',
		description: 'Label for info icon in disclaimer text.',
	},
	aiIconLabel: {
		defaultMessage: 'Atlassian Intelligence',
		id: 'atlassian-intelligence.common.ai-footer.ai-icon-label',
		description: 'Label for Atlassian Intelligence icon.',
	},
});
export default messages;
